import {
  Component,
  ViewChild,
  PLATFORM_ID,
  Inject,
  OnDestroy,
  OnInit,
  ElementRef,
  HostListener,
  ChangeDetectorRef,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { CarouselComponent, OwlOptions } from 'ngx-owl-carousel-o';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../shared/services/api.service';
import { CartService } from '../../shared/services/cart.service';
import {
  CommonModule,
  isPlatformBrowser,
  ViewportScroller,
} from '@angular/common';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CompareComponent } from '../compare/compare.component';
import { PartsforyouComponent } from '../partsforyou/partsforyou.component';
import { RecentlyViewedPartsComponent } from '../recently-viewed-parts/recently-viewed-parts.component';
import { CouponComponent } from '../coupon/coupon.component';
import { AddressComponent } from '../address/address.component';
import { GstComponent } from '../gst/gst.component';
import { LoginComponent } from '../login/login.component';
import { LoaderService } from '../../shared/services/loader.service';
import { SimilarProductComponent } from '../components/similar-product/similar-product.component';
import { BreadcrumComponent } from '../breadcrum/breadcrum.component';
import { FormsModule } from '@angular/forms';
import { PaymentService } from '../../shared/services/payment.service';
import { ScrapCertificateService } from '../../shared/services/scrap-certificate.service';
import { ScrapCertificateModalComponent } from '../../shared/components/scrap-certificate-modal/scrap-certificate-modal.component';
import {
  SCRAP_CERT_NAME_PATTERN,
  SCRAP_CERT_NUMBER_PATTERN,
} from '../../shared/constants/scrap-certificate-validation';
import { WishlistStorageService } from '../../shared/services/wishlist-storage.service';
import { NotificationService } from '../../shared/services/notification.service';
import { DeferLoadDirective } from '../../shared/directives/defer-load.directive';
import { ProductNamePipe } from '../../shared/pipes/product-name.pipe';
import {
  appendOnlinePaymentFields,
  assignPaymentFlow,
  extractPriceBreakup,
  getOnlinePaymentFields,
  toAmountNumber,
} from '../../shared/constants/payment-flow';
import { BuyerVerificationService } from '../../shared/services/buyer-verification.service';
import { ModalService } from '../../shared/services/modal.service';
import { AuthService } from '../../shared/services/auth.service';
import {
  formatAddress as formatAddressUtil,
  hasAddress as hasAddressUtil,
  shouldShowBillingBlock as shouldShowBillingBlockUtil,
} from '../../shared/utils/address.utils';
import {
  canAddGstDetails as canAddGstDetailsUtil,
  canPlaceOrder as canPlaceOrderUtil,
} from '../../shared/utils/gst-eligibility';

@Component({
  selector: 'app-product-detail',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PartsforyouComponent,
    SimilarProductComponent,
    BreadcrumComponent,
    CouponComponent,
    AddressComponent,
    GstComponent,
    LoginComponent,
    CompareComponent,
    FormsModule,
    ScrapCertificateModalComponent,
    DeferLoadDirective,
    ProductNamePipe,
  ],
  templateUrl: './product-detail.component.html',
  styleUrl: './product-detail.component.scss',
})
export class ProductDetailComponent implements OnDestroy, OnInit {
  showPartsForYouSection = false;
  showSimilarProductsSection = false;
  showQuantityError: boolean = false;
  quantityTouched: boolean = false;
  @ViewChild('addMoreFileInput')
  addMoreFileInput!: ElementRef<HTMLInputElement>;

  text: string = 'home';
  text1: any;
  isActive: boolean = false;
  isScrapPart: boolean = false;

  // Breadcrumb properties
  productCategory: string = '';
  productName: string = '';
  previewData: any = {};

  // @ViewChild('thumbsCarousel') thumbsCarousel!: CarouselComponent;
  title: string = '';
  specifications = [];
  items = [];

  unit: string = 'ton';
  quantity: number = 5;
  quickQuantities: number[] = [5, 10, 20, 25];
  private previousUnit: string = 'ton';

  // Get minimum quantity based on current unit from API
  get minQuantity(): number {
    const partDetail = this.productDetailData?.part_detail;
    if (!partDetail) return 0;

    // Use API values: min_quantity or min_qty
    const minQtyInKg =
      partDetail.min_quantity || partDetail.min_qty || 0;
    return this.unit === 'ton' ? minQtyInKg / 1000 : minQtyInKg;
  }

  // Get maximum quantity based on current unit from API
  get maxQuantity(): number {
    const partDetail = this.productDetailData?.part_detail;
    if (!partDetail) return 0;

    // Use API values: max_booking_qty, max_booking_quantity, max_quantity or available_quantity
    const maxQtyInKg =
      partDetail.max_booking_qty ||
      partDetail.max_booking_quantity ||
      partDetail.max_quantity ||
      partDetail.available_quantity ||
      0;
    return this.unit === 'ton' ? maxQtyInKg / 1000 : maxQtyInKg;
  }

  // Check if a quick quantity button should be highlighted
  isQuickQuantitySelected(qty: number): boolean {
    if (this.unit === 'ton') {
      return Math.abs(this.quantity - qty) < 0.01;
    } else if (this.unit === 'kg') {
      return (
        Math.abs(this.quantity - qty * 1000) < 1 ||
        Math.abs(this.quantity - qty) < 0.01
      );
    } else {
      return Math.abs(this.quantity - qty) < 0.01;
    }
  }

  // Get display value for quick quantity button based on current unit
  getQuickQuantityDisplay(qty: number): string {
    // Show static values without conversion
    return qty.toString();
  }
  userLocation: any;
  priceBreakup: any = {};
  payFullAmount: boolean = false;
  showFullPaymentConfirm: boolean = false;
  brands: any[] = [];
  modelList: any[] = [];
  yearList: string[] = [];
  categoryList: any[] = [];
  showMore: boolean = false;
  isLongText: boolean = false;
  displayText: string = '';
  fullText: any;

  selectQuantity(qty: number) {
    // Mark quantity as touched (similar to product-list)
    this.quantityTouched = true;

    // Quick quantity buttons are explicitly in tons (5 ton, 10 ton, 20 ton, 25 ton)
    // Switch unit to ton and set quantity to the clicked ton value
    this.unit = 'ton';
    this.previousUnit = 'ton';
    this.quantity = qty;

    // Show error if validation fails
    this.showQuantityError = !this.isQuantityValid();
    this.triggerPriceBreakupUpdate();
    this.cdr.markForCheck();
  }

  onUnitChange() {
    // Mark quantity as touched when unit changes (similar to product-list)
    this.quantityTouched = true;

    if (this.quantity && this.quantity > 0) {
      if (this.previousUnit === 'kg' && this.unit === 'ton') {
        this.quantity = Math.round((this.quantity / 1000) * 10) / 10;
      } else if (this.previousUnit === 'ton' && this.unit === 'kg') {
        this.quantity = Math.round(this.quantity * 1000);
      }
    }
    this.previousUnit = this.unit;

    // Show error if validation fails
    this.showQuantityError = !this.isQuantityValid();
    this.triggerPriceBreakupUpdate();
    this.cdr.markForCheck();
  }

  onQuantityChange(value: any) {
    // Mark quantity as touched (similar to product-list)
    this.quantityTouched = true;

    // Convert to number
    const numValue = Number(value);

    // If invalid or empty, don't set quantity (let user enter)
    if (isNaN(numValue) || value === '' || value === null) {
      this.quantity = 0;
    } else {
      // For ton unit
      if (this.unit === 'ton') {
        // Round to 1 decimal place for ton, allow user to type freely
        this.quantity = Math.round(numValue * 10) / 10;
      } else {
        // For kg or liter unit, allow user to type freely
        this.quantity = Math.round(numValue);
      }
    }

    // Show error if validation fails
    this.showQuantityError = !this.isQuantityValid();
    this.triggerPriceBreakupUpdate();
  }

  onQuantityInput() {
    // Mark quantity as touched on blur
    this.quantityTouched = true;

    // Don't cap quantity - let error persist if invalid
    // User should see the error message, not auto-corrected value

    // Show error if validation fails
    this.showQuantityError = !this.isQuantityValid();
    this.triggerPriceBreakupUpdate();
  }

  toggleSeeMore() {
    this.showMore = !this.showMore;
    this.displayText = this.showMore
      ? this.fullText
      : this.fullText.substring(0, 50) + '...';
  }

  images = [
    {
      url: 'https://cdn.builder.io/api/v1/image/assets/TEMP/660849e811a53bb88c9bc0e71d58458a6d9e977c?apiKey=cb544d29e73245039207efcd0a1a6bc7',
      alt: 'Main Image',
    },
    {
      url: 'https://cdn.builder.io/api/v1/image/assets/TEMP/c5edf15a4814b9fef75afb145eefb7b925224be2?apiKey=cb544d29e73245039207efcd0a1a6bc7',
      alt: 'Thumb 1',
    },
    {
      url: 'https://cdn.builder.io/api/v1/image/assets/TEMP/c5edf15a4814b9fef75afb145eefb7b925224be2?apiKey=cb544d29e73245039207efcd0a1a6bc7',
      alt: 'Thumb 2',
    },
    {
      url: 'https://cdn.builder.io/api/v1/image/assets/TEMP/c5edf15a4814b9fef75afb145eefb7b925224be2?apiKey=cb544d29e73245039207efcd0a1a6bc7',
      alt: 'Thumb 3',
    },
    {
      url: 'https://cdn.builder.io/api/v1/image/assets/TEMP/c5edf15a4814b9fef75afb145eefb7b925224be2?apiKey=cb544d29e73245039207efcd0a1a6bc7',
      alt: 'Thumb 4',
    },
    {
      url: 'https://cdn.builder.io/api/v1/image/assets/TEMP/c5edf15a4814b9fef75afb145eefb7b925224be2?apiKey=cb544d29e73245039207efcd0a1a6bc7',
      alt: 'Thumb 5',
    },
  ];

  activeImageIndex = 0;

  benefits = [
    {
      icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/f4db0fb10112d8fe35db0d4f6866cab69f82c3d5?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
      text: '7 Days Return',
      description:
        'You can return this item within 7 days of delivery for a refund or replacement. The item must be in its original condition with all packaging and accessories.',
    },
    {
      icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/5df054051e3a267b8fb0fbdddb5461244981a137?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
      text: 'Part Certified',
      description:
        'This product has been tested and verified for quality and performance. Backed by a trusted certification process.',
    },
    {
      icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/196fc5196586a9f53b51556350f8a9f630ad337c?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
      text: 'Get Delivered',
      description:
        'Estimated delivery in 2-5 business days. Shipping costs may apply based on location.',
    },
    {
      icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/30a289c79056bb57ecad77e835d55a98dfc92265?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
      text: 'Store Pickup',
      description:
        'Available for pickup at select locations. Choose your preferred store at checkout.',
    },
  ];

  Scrapbenefits = [
    // {
    //   icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/5df054051e3a267b8fb0fbdddb5461244981a137?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
    //   text: 'Part Certified',
    //   description:
    //     'This product has been tested and verified for quality and performance. Backed by a trusted certification process.',
    // },
    {
      icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/30a289c79056bb57ecad77e835d55a98dfc92265?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
      text: 'Store Pickup',
      description:
        'Available for pickup at select locations. Choose your preferred store at checkout.',
    },
  ];

  productSpecifications: any; // = [

  donorVehicleSpecifications: any;

  expanded: boolean = false;
  expandedProductSpecs: boolean = false;
  expandedDonorSpecs: boolean = false;
  isOpen: boolean = false;
  hasBorder: boolean = false;
  isFormOpen = false;
  partForm: FormGroup;
  fileName: string = '';
  selectedBenefit: any = null;
  selectedIndex: number | null = null;
  selectedImage: string = 'assets/images/clutch-bearing.jpg';
  selectedThumbnailIndex: number = 1;
  productDetailData: any;
  vcNumber: any;
  chasisNumber: any;
  isMobile: boolean = false;
  isStorePickup: boolean = false;

  private productSubscription: Subscription = new Subscription();
  private routeSubscription: Subscription = new Subscription();
  private productData$ = new BehaviorSubject<any>(null);
  private priceBreakupSubject$ = new Subject<void>();
  private brandListCache: any[] | null = null;

  // --- Buy Now Popup State and Methods ---
  isBuyNowAnimating = false;
  isBuyNowPopupOpen = false;
  deliveryMethod: 'home' | 'pickup' = 'home';
  addBillingDetails = false;
  addGSTIN = false;
  selectedDeliveryOption: 'home' | 'store' = 'home';
  isFavorite: boolean = false;

  // Add new properties for popups
  showBillingPopup = false;
  showGSTINPopup = false;
  selectedBillingOption: any;
  paymentErrorMessage: string | null = null;

  get canPlaceOrder(): boolean {
    return canPlaceOrderUtil(this.userData);
  }
  sub: Subscription = new Subscription();
  wishlist: any;

  // Add new properties for address functionality
  showAddressSelectionPopup = false;
  addresses: any = [];
  selectedAddressId: string = '';
  addressType: 'shipping' | 'billing' = 'shipping';
  userData: any;
  showLoginModalpop = true;

  get canAddGstDetails(): boolean {
    return canAddGstDetailsUtil(this.userData);
  }

  // Add properties for coupon functionality
  showCouponPopup = false;
  availableCoupons: any[] = [];
  selectedCoupon: any = null;
  private couponsLoaded = false;

  // Add property for login popup
  showLoginModal = false;
  currentAction: string = 'productDeytail';

  // Add property for form submission loading state
  isSubmitting = false;
  orderDetail: any;
  itemAddedToCart = false; // Add this property to track cart success state
  ccavenue: any;
  oreder_number: any;
  // paymentService: any;
  formBuilder: any;

  // Get delivery date (3 business days from today)
  getDeliveryDate(): string {
    const today = new Date();
    let daysToAdd = 3;
    let currentDate = new Date(today);

    while (daysToAdd > 0) {
      currentDate.setDate(currentDate.getDate() + 1);
      // Skip weekends (0 = Sunday, 6 = Saturday)
      if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
        daysToAdd--;
      }
    }

    // Format as "Mon, 2 July"
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    const dayName = dayNames[currentDate.getDay()];
    const day = currentDate.getDate();
    const month = monthNames[currentDate.getMonth()];

    return `${dayName}, ${day} ${month}`;
  }

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private apiService: ApiService,
    private cartService: CartService,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private viewportScroller: ViewportScroller,
    public paymentService: PaymentService,
    private cdr: ChangeDetectorRef,
    private scrapCertificateService: ScrapCertificateService,
    private wishlistStorageService: WishlistStorageService,
    private notificationService: NotificationService,
    private buyerVerificationService: BuyerVerificationService,
    private authService: AuthService,
    private modalService: ModalService,
  ) {
    this.formBuilder = this.fb;
    // this.sub.add(
    //   this.route.params.subscribe((params) => {
    //     localStorage.setItem('part_number', params['id']);
    //     this.testApiCall(params['id']);
    //   })
    // );
    this.partForm = this.fb.group({
      partName: [
        '',
        [Validators.required, Validators.pattern(/^[a-zA-Z0-9 ]+$/)],
      ],
      brand: ['', Validators.required],
      vehicleModel: ['', Validators.required],
      year: ['', Validators.required],
      category: ['', Validators.required],
      attachment: [''],
      remarks: [''],
    });
  }

  ngOnInit(): void {
    // Setup debounced price breakup updates
    this.sub.add(
      this.priceBreakupSubject$
        .pipe(
          debounceTime(500), // Wait 500ms after last change
        )
        .subscribe(() => {
          this.getPricebreakup();
        }),
    );

    // Sync inline scrap modal visibility with shared service so it opens immediately after API checks
    this.sub.add(
      this.scrapCertificateService.showScrapCertificateModal$.subscribe(
        (show) => {
          this.showScrapCertificateModal = show;
          this.updateBodyScroll();
        },
      ),
    );
    // Initialize the certificate form
    this.certificateForm = this.fb.group({
      scrapCategory: ['', Validators.required],
      certificateName: [
        '',
        [Validators.required, Validators.pattern(SCRAP_CERT_NAME_PATTERN)],
      ],
      certificateNumber: [
        '',
        [
          Validators.required,
          Validators.pattern(SCRAP_CERT_NUMBER_PATTERN),
        ],
      ],
      issuingAuthority: [
        '',
        [Validators.required, Validators.pattern(SCRAP_CERT_NAME_PATTERN)],
      ],
      companyName: [
        '',
        [Validators.required, Validators.pattern(SCRAP_CERT_NAME_PATTERN)],
      ],
      issueDate: ['', Validators.required],
      expiryDate: ['', Validators.required],
    });

    // Check if we should preserve scroll position
    //this.getBrandList();

    if (isPlatformBrowser(this.platformId)) {
      this.addPageVisibilityListener();
    }

    this.sub.add(
      this.route.queryParams.subscribe((queryParams) => {
        const preserveScroll = queryParams['preserveScroll'] === 'true';
        // Handle scroll behavior based on navigation context
        this.handleScrollBehavior(preserveScroll);

        // Clear the preserveScroll parameter to avoid interference with future navigation
        if (preserveScroll) {
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { preserveScroll: null },
            queryParamsHandling: 'merge',
          });
        }
      }),
    );

    // Also check if we're navigating from a similar context based on referrer
    if (isPlatformBrowser(this.platformId)) {
      const referrer = document.referrer;
      const currentUrl = window.location.href;

      // If the referrer contains 'product-detail' and we're going to a different product,
      // it might be a good candidate for preserving scroll position
      if (
        referrer &&
        referrer.includes('product-detail') &&
        !referrer.includes(currentUrl)
      ) {
        // This is navigation between different products, preserve scroll position
        this.handleScrollBehavior(true);
      }

      // Check if coming from search or filter context
      if (
        referrer &&
        (referrer.includes('product-list') || referrer.includes('search'))
      ) {
        // Coming from search/filter, preserve scroll position for better UX
        this.handleScrollBehavior(true);
      }
    }

    this.sub.add(
      this.route.params.subscribe((params) => {
        localStorage.setItem('part_number', params['id']);
        this.testApiCall(params['id']);
      }),
    );
    if (isPlatformBrowser(this.platformId)) {
      this.updateIsMobile();
      try {
        const userDataString = localStorage.getItem('userData1');
        if (userDataString) {
          if (userDataString.startsWith('U2FsdGVkX1')) {
            this.userData = {};
          } else {
            this.userData = JSON.parse(userDataString);
          }
        } else {
          this.userData = {};
        }
      } catch (error) {
        console.error('Error parsing userData1 from localStorage:', error);
        this.userData = {};
      }

      this.sub.add(
        this.authService.isLoggedIn$.subscribe((loggedIn) => {
          if (loggedIn) {
            this.applyStoredUser();
          } else {
            this.userData = {};
          }
          this.cdr.markForCheck();
        }),
      );

      const categoryType = JSON.parse(
        localStorage.getItem('product_categoryType') || 'null',
      );
      this.isScrapPart = categoryType === 'Scrap Part';

      if (this.userData.id) {
        this.routeSubscription = this.route.params.subscribe((params) => {
          localStorage.setItem('part_number', params['id']);
          this.getWishlistData(params['id']);

          // this.getProductDetailData(params['id']);
          const productId = params['id'];

          let visitedProducts: string[] = JSON.parse(
            localStorage.getItem('visitedProductIds') || '[]',
          );

          if (!visitedProducts.includes(productId)) {
            visitedProducts.push(productId);
          }

          localStorage.setItem(
            'visitedProductIds',
            JSON.stringify(visitedProducts),
          );
        });
        // Defer address list API until user opens address selection in Buy Now popup.
        this.userLocation = JSON.parse(
          localStorage.getItem('userLocation') || '{}',
        );
        console.log(
          'userLocation',
          JSON.parse(localStorage.getItem('userLocation') || '{}'),
        );
      }

      // Load addresses when component initializes
    }

    //check long text
    if (this.fullText?.length > 200) {
      this.isLongText = true;
      this.displayText = this.fullText.substring(0, 200) + '...';
    } else {
      this.displayText = this.fullText;
      this.isLongText = false;
    }
  }

  alphaNumberOnly(event: any) {
    var inp = String.fromCharCode(event.keyCode);

    const data = /[a-zA-Z0-9 ]/;

    if (data.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  getBrandList() {
    // Return cached data if available
    if (this.brandListCache !== null) {
      this.brands = this.brandListCache;
      this.partForm.patchValue({
        brand: '',
        vehicleModel: '',
        year: '',
        category: '',
      });
      return;
    }

    const payload = {
      action_type: 'make',
      make_list: [],
      model_list: [],
      variant_list: [],
      year_of_manufacture: '',
      offset: 0,
      limit: 10,
    };

    this.sub.add(
      this.apiService.getBrand(payload).subscribe({
        next: (res) => {
          if (res.success && Array.isArray(res.data?.Vehicle_Brands_List)) {
            // Cache the brand list
            this.brandListCache = res.data.Vehicle_Brands_List;
            this.brands = this.brandListCache!;
            this.partForm.patchValue({
              brand: '',
              vehicleModel: '',
              year: '',
              category: '',
            });
          } else {
            this.brands = [];
          }
        },
        error: (err) => {
          console.error('Failed to fetch brands', err);
          this.notificationService.error(
            err?.error?.data?.msg || 'Failed to fetch brands',
          );
        },
      }),
    );
  }

  onBrandSelect(event: any) {
    const selectedBrand =
      event.target?.value || this.partForm.get('brand')?.value;

    if (!selectedBrand) {
      this.modelList = [];
      this.yearList = [];
      this.categoryList = [];
      this.partForm.patchValue({ vehicleModel: '', year: '', category: '' });
      return;
    }

    const payload = {
      action_type: 'model',
      make_list: [selectedBrand],
      model_list: [],
      variant_list: [],
      year_of_manufacture: '',
      offset: 0,
      limit: 10,
    };

    this.sub.add(
      this.apiService.getBrand(payload).subscribe({
        next: (res) => {
          if (res.data) {
            // Extract model names from each object
            this.modelList = res.data?.Vehicle_Models_List.map(
              (item: { PARENT_MODEL_s: string }) => ({
                model_name: item.PARENT_MODEL_s,
              }),
            );
            console.log('modellist', this.modelList);
          } else {
            this.modelList = [];
            console.log(this.modelList);
          }

          // Reset dependent fields
          this.yearList = [];
          this.categoryList = [];
          this.partForm.patchValue({
            vehicleModel: '',
            year: '',
            category: '',
          });
        },
        error: (err) => {
          console.error('Failed to fetch models', err);
          this.notificationService.error(
            err?.error?.data?.msg || 'Failed to fetch models',
          );
          this.modelList = [];
          this.yearList = [];
          this.categoryList = [];
        },
      }),
    );
  }

  onModelSelect(event: any) {
    const selectedBrand = this.partForm.get('brand')?.value;
    const selectedModel =
      event.target?.value || this.partForm.get('vehicleModel')?.value;

    if (!selectedBrand || !selectedModel) {
      this.yearList = [];
      this.categoryList = [];
      this.partForm.patchValue({ year: '', category: '' });
      return;
    }

    const payload = {
      action_type: 'year_of_manufacture',
      make_list: [selectedBrand],
      model_list: [selectedModel],
      variant_list: [],
      year_of_manufacture: '',
      offset: 0,
      limit: 10,
    };

    this.sub.add(
      this.apiService.getBrand(payload).subscribe({
        next: (res) => {
          if (res.data) {
            // Extract years from each object
            this.yearList = res.data?.Vehicle_Year.map(
              (item: { YEAR_OF_MANUFACTURE_s: string }) =>
                item.YEAR_OF_MANUFACTURE_s,
            );
          } else {
            this.yearList = [];
          }

          // Reset dependent fields
          this.categoryList = [];
          this.partForm.patchValue({ year: '', category: '' });
        },
        error: (err) => {
          console.error('Failed to fetch years', err);
          this.notificationService.error(
            err?.error?.data?.msg || 'Failed to fetch years',
          );
          this.yearList = [];
          this.categoryList = [];
        },
      }),
    );
  }
  onYearSelect(event: any) {
    const selectedBrand = this.partForm.get('brand')?.value;
    const selectedModel = this.partForm.get('vehicleModel')?.value;
    const selectedYear =
      event.target?.value || this.partForm.get('year')?.value;

    if (!selectedBrand || !selectedModel || !selectedYear) {
      this.categoryList = [];
      this.partForm.patchValue({ category: '' });
      return;
    }

    const payload = {
      action_type: 'variant',
      make_list: [selectedBrand],
      model_list: [selectedModel],
      variant_list: [],
      year_of_manufacture: selectedYear,
      offset: 0,
      limit: 10,
    };
    this.sub.add(
      this.apiService.getBrand(payload).subscribe({
        next: (res) => {
          if (res.data) {
            // Extract category names from each object
            this.categoryList = res.data?.Vehicle_Variant_List.map(
              (item: { VARIANT_s: string }) => ({
                category_name: item.VARIANT_s,
              }),
            );
          } else {
            this.categoryList = [];
          }
          // Reset dependent field
          this.partForm.patchValue({ category: '' });
        },
        error: (err) => {
          console.error('Failed to fetch categories', err);
          this.notificationService.error(
            err?.error?.data?.msg || 'Failed to fetch categories',
          );
          this.categoryList = [];
        },
      }),
    );
  }

  onCategorySelect(event: any) {
    const selectedBrand = this.partForm.get('brand')?.value;
    const selectedModel = this.partForm.get('vehicleModel')?.value;
    const selectedYear = this.partForm.get('year')?.value;
    const selectedCategory =
      event.target?.value || this.partForm.get('category')?.value;

    if (
      !selectedBrand ||
      !selectedModel ||
      !selectedYear ||
      !selectedCategory
    ) {
      this.partForm.patchValue({ category: '' });
      return;
    }

    const payload = {
      action_type: 'Get Vehicle Details',
      make_list: [selectedBrand],
      model_list: [selectedModel],
      variant_list: [selectedCategory],
      year_of_manufacture: selectedYear,
      offset: 0,
      limit: 10,
    };

    this.sub.add(
      this.apiService.getBrand(payload).subscribe({
        next: (res) => {
          if (res?.success) {
            // API returned success
            this.previewData = res?.data?.[0] || {};
            // this.showConfirmation = true;
          } else {
            console.warn('No data found:', res?.data?.msg);
          }
        },
        error: (err) => {
          console.error('Failed to proceed', err);
          this.notificationService.error(
            err?.error?.data?.msg || 'Failed to fetch vehicle details',
          );
        },
      }),
    );
  }

  selectBenefit(index: number) {
    this.selectedIndex = this.selectedIndex === index ? null : index;
  }

  onBenefitClick(event: MouseEvent, index: number) {
    event.stopPropagation();
    this.selectedIndex = this.selectedIndex === index ? null : index;
  }

  onCloseBenefitClick(event: MouseEvent) {
    event.stopPropagation();
    this.selectedIndex = null;
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.updateIsMobile();
    }
  }

  private updateIsMobile(): void {
    // Align with Tailwind `md` (768px) so mobile/desktop branches match CSS
    this.isMobile = window.innerWidth < 768;
  }

  @HostListener('document:click')
  onDocumentClick() {
    // Close tooltip when clicking outside
    if (this.selectedIndex !== null) {
      this.selectedIndex = null;
    }
  }

  /**
   * Check if any popup is currently open
   */
  private isAnyPopupOpen(): boolean {
    return (
      this.isFormOpen ||
      this.isOpen ||
      this.isBuyNowPopupOpen ||
      this.showAddressSelectionPopup ||
      this.showCouponPopup ||
      this.showLoginModal ||
      this.isPopupVisible ||
      this.isSocialShareOpen ||
      this.showScrapCertificateModal ||
      this.showBillingPopup ||
      this.showGSTINPopup
    );
  }

  /**
   * Update body scroll based on popup state
   */
  private updateBodyScroll(): void {
    if (this.isAnyPopupOpen()) {
      this.modalService.openModal('pdp-popups', () => this.closeActivePopup());
    } else {
      this.modalService.closeModal('pdp-popups');
    }
  }

  private closeActivePopup(): void {
    if (this.isSocialShareOpen) {
      this.isSocialShareOpen = false;
    } else if (this.isFormOpen) {
      this.closePartRequestForm();
    } else if (this.showLoginModal) {
      this.closeLoginPopup();
    } else if (this.isBuyNowPopupOpen) {
      this.closeBuyNowPopup();
    } else if (this.showCouponPopup) {
      this.showCouponPopup = false;
    } else if (this.showAddressSelectionPopup) {
      this.showAddressSelectionPopup = false;
    } else if (this.showBillingPopup) {
      this.showBillingPopup = false;
    } else if (this.showGSTINPopup) {
      this.showGSTINPopup = false;
    } else if (this.showScrapCertificateModal) {
      this.showScrapCertificateModal = false;
    } else if (this.isOpen) {
      this.isOpen = false;
    } else if (this.isPopupVisible) {
      this.isPopupVisible = false;
    }
    this.cdr.markForCheck();
  }

  openPartRequestForm() {
    this.isFormOpen = true;
    this.partForm.reset();
    this.fileName = '';
    this.updateBodyScroll();

    this.getBrandList();
  }

  closePartRequestForm() {
    this.isFormOpen = false;
    this.isOpen = false;
    this.partForm.reset();
    this.fileName = '';
    this.updateBodyScroll();
  }
  onSubmitenquiry() {
    if (this.partForm.valid) {
      this.isSubmitting = true;

      // Create FormData object
      const formData = new FormData();
      formData.append('part_name', this.partForm.get('partName')?.value || '');
      formData.append('brand', this.partForm.get('brand')?.value || '');
      formData.append(
        'vehicle_model',
        this.partForm.get('vehicleModel')?.value || '',
      );
      formData.append(
        'year_of_manufacturing',
        this.partForm.get('year')?.value || '',
      );
      formData.append('category', this.partForm.get('category')?.value || '');
      formData.append('remarks', this.partForm.get('remarks')?.value || '');

      // Add file if selected
      const file = this.partForm.get('attachment')?.value;
      if (file && file instanceof File) {
        formData.append('image_file', file, file.name);
      }
      this.loaderService.show();

      // API submission logic here
      this.sub.add(
        this.apiService.enquiryNow(formData).subscribe({
          next: (res) => {
            // Show success message and close form after successful submission
            this.closePartRequestForm();
            this.partForm.reset();
            this.notificationService.success('Enquiry submitted successfully');
            this.loaderService.hide();
          },
          error: (err) => {
            this.notificationService.error(
              err?.error?.data?.msg || 'Failed to submit enquiry',
            );
            this.loaderService.hide();
          },
          complete: () => {
            this.isSubmitting = false;
            this.loaderService.hide();
          },
        }),
      );
    } else {
      // Mark fields as touched to show validation errors
      Object.keys(this.partForm.controls).forEach((key) => {
        this.partForm.get(key)?.markAsTouched();
      });
      this.notificationService.error('Please fill in all required fields.');
    }
  }

  closeForm() {
    // Handle close logic here
  }

  testApiCall(productId: any) {
    this.loaderService.show();
    const testPayload = {
      part_number: productId,
    };

    this.sub.add(
      this.apiService.getProductDetailData(testPayload).subscribe({
        next: (res) => {
          if (res) {
            this.productDetailData = res.data;
            this.fullText =
              this.productDetailData.part_detail?.short_desc_s || '';

            // Initialize display text and check if text is long
            this.isLongText = this.fullText.length > 50;
            this.displayText = this.isLongText
              ? this.fullText.substring(0, 50) + '...'
              : this.fullText;
            this.cdr.detectChanges();
            const partDetail = this.productDetailData.part_detail;
            if (partDetail?.part_type === 'Scrap Part') {
              this.isScrapPart = true;
            }
            this.vcNumber = partDetail?.vc_number;
            this.chasisNumber = partDetail?.chassis_number;
            const currentId =
              partDetail?.inventory_id || partDetail?.part_number || productId;
            if (!this.userData?.id) {
              const localItems = this.cartService.getLocalStorageCartItems();
              this.itemAddedToCart = localItems.some(
                (item: any) =>
                  item &&
                  (item.inventory_id === currentId ||
                    item.part_number === currentId ||
                    item.id === currentId),
              );
            } else {
              this.itemAddedToCart = false; // Set success state
            }

            // Initialize unit based on product type - check if oil/fluids with liter UOM
            if (this.isOilProductWithLiter(partDetail)) {
              this.unit = 'liter';
              console.log('✅ PDP: Unit set to LITER', {
                name: partDetail.table_name,
                default_uom: partDetail.default_uom,
                material: partDetail.material,
                scrap_category: partDetail.scrap_category,
              });
            } else {
              this.unit = 'ton';
              console.log('✅ PDP: Unit set to TON (scrap product)', {
                name: partDetail.table_name,
                default_uom: partDetail.default_uom,
                material: partDetail.material,
                scrap_category: partDetail.scrap_category,
              });
            }
            this.previousUnit = this.unit;

            // Initialize quantity based on product min_qty (matching product-list logic)
            if (this.isScrapPart) {
              const minQtyInKg =
                partDetail.min_quantity || partDetail.min_qty || 0;
              const maxQtyInKg =
                partDetail.max_booking_qty ||
                partDetail.max_booking_quantity ||
                partDetail.max_quantity ||
                partDetail.available_quantity ||
                0;

              // For scrap parts, set initial quantity to min_qty, but cap at available_quantity
              if (minQtyInKg > 0) {
                const initialQtyInKg =
                  maxQtyInKg > 0
                    ? Math.min(minQtyInKg, maxQtyInKg)
                    : minQtyInKg;
                this.quantity =
                  this.unit === 'ton'
                    ? initialQtyInKg / 1000
                    : initialQtyInKg;
              } else {
                this.quantity = 0;
              }
            } else {
              // For Used Parts, default quantity is 1
              this.quantity = 1;
            }

            // Set breadcrumb data
            this.productCategory = partDetail?.GROUP_NAME_s || '';
            // Use part_name for Used Parts, table_name for others
            this.productName =
              partDetail?.part_type === 'Used Part'
                ? partDetail?.part_name || partDetail?.table_name || ''
                : partDetail?.table_name || partDetail?.part_name || '';

            // Fetch available coupons for this product
            // Defer coupons API until coupon UI is opened/visible.
            this.couponsLoaded = false;

            this.productSpecifications = [
              [
                { label: 'Category', value: partDetail.scrap_category || '-' },
                {
                  label: 'Sub - category',
                  value: partDetail.sub_category || '-',
                },
              ],
              [
                { label: 'Weight', value: partDetail.weight || '-' }, // Assuming `weight` exists; otherwise use another field
                {
                  label: 'OEM Number',
                  value: partDetail.TEVPM_PART_NUMBER_s || '-',
                },
              ],
              [
                { label: 'Dimension', value: partDetail.dimension || '-' }, // Assuming `dimension` exists; add logic if needed
                { label: 'Header', value: partDetail.short_desc_s || '-' },
              ],
            ];

            this.donorVehicleSpecifications = [
              [
                {
                  label: 'Brand',
                  value: partDetail.make || '-',
                },
                {
                  label: 'Vehicle Model',
                  value: partDetail.model || '-',
                },
              ],
              [
                { label: 'Variant', value: partDetail.variant || '-' },
                {
                  label: 'Manufacturing Year',
                  value: partDetail.year_of_manufacture || '-',
                },
              ],
              [
                { label: 'BS', value: 'BS 4' }, // Static fallback (you can bind if dynamic)
                { label: 'Fuel Type', value: 'Petrol' }, // Static fallback (you can bind if dynamic)
              ],
              [
                { label: 'Break Type', value: 'Disc(Front), Drum(Rear)' }, // Static fallback (you can bind if dynamic)
                { label: 'Transmission', value: 'Automatic' }, // Static fallback (you can bind if dynamic)
              ],
            ];
            // this.isFavorite = data?.is_in_wishlist ? true : false;
            const defaultImage = 'assets/default.webp';
            const imagePaths = res.data?.part_detail?.part_image_path;

            this.images = (
              Array.isArray(imagePaths) && imagePaths.length > 0
                ? imagePaths
                : [defaultImage]
            ).map((img: string, index: number) => ({
              url: img,
              alt: `Image ${index + 1}`,
            }));
          }
          this.getPricebreakup();
          this.loaderService.hide();
        },
        error: (err) => {
          this.notificationService.error(
            err?.error?.data?.msg || 'Failed to load product details',
          );
          this.loaderService.hide();
        },
        complete: () => {
          this.loaderService.hide();
        },
      }),
    );
  }

  toggleProductSpecs() {
    this.expandedProductSpecs = !this.expandedProductSpecs;
  }

  toggleDonorSpecs() {
    this.expandedDonorSpecs = !this.expandedDonorSpecs;
  }

  toggleExpanded(): void {
    this.expanded = !this.expanded;
  }

  // Set active image and update main carousel
  setActive(index: number) {
    this.activeImageIndex = index;
    // If you have a reference to the main carousel, you could slide to this index
  }

  // Previous image button handler
  prevImage() {
    this.activeImageIndex =
      this.activeImageIndex === 0
        ? this.images.length - 1
        : this.activeImageIndex - 1;
  }

  // Next image button handler
  nextImage() {
    this.activeImageIndex = (this.activeImageIndex + 1) % this.images.length;
  }

  openGradingGuide() {
    this.isOpen = true;
    this.updateBodyScroll();
  }

  selectImage(index: number) {
    this.selectedThumbnailIndex = index;
    this.selectedImage = `assets/images/clutch-bearing-${index}.jpg`;
  }

  gotoCart() {
    this.cartService.navigateToCart();
  }

  addToCart(part_number: any) {
    // Mark quantity as touched when user tries to add to cart (similar to product-list)
    this.quantityTouched = true;
    this.cdr.markForCheck();

    // Check quantity validation for both Scrap and Used parts
    // For Used Parts: validate against available_quantity
    // For Scrap Parts: validate against min_quantity and available_quantity
    if (!this.isQuantityValid()) {
      this.showQuantityError = true;
      return;
    }

    // Stock availability check
    if (!this.checkStockAvailability()) {
      return;
    }
    // Check if user is logged in
    const isLoggedIn = this.authService.isLoggedIn;
    const hasUser = isLoggedIn && this.userData && this.userData.id;
    if (!hasUser) {
      if (this.isScrapPart) {
        this.addScrapItemToCart(part_number);
      } else {
        this.addToCartForNonScrapParts(part_number);
      }
      return;
    }

    // Check certificate requirement
    const isCertRequired =
      this.productDetailData?.part_detail?.is_certificate_required === 'True';
    if (isCertRequired) {
      // Use the shared service to handle scrap part detection
      this.cartService.handleAddToCart(
        this.productDetailData, // Pass the full product data
        'Store Pickup',
        this.quantity,
        this.unit,
        () => {
          // Callback for non-scrap parts
          this.addToCartForNonScrapParts(part_number);
        },
        () => {
          // Callback for login required
          this.openLoginPopup('add_to_cart');
        },
      );
    } else {
      // No certificate required, add to cart directly
      this.addToCartForNonScrapParts(part_number);
    }
  }

  private addToCartForNonScrapParts(part_number: any) {
    // Check if user is logged in
    if (!this.userData || !this.userData.id) {
      const fullItem = this.productDetailData?.part_detail
        ? {
            ...this.productDetailData.part_detail,
            inventory_id:
              this.productDetailData.part_detail.inventory_id ||
              part_number ||
              this.productDetailData.part_detail.part_number,
          }
        : (typeof part_number === 'object' && part_number !== null
            ? part_number
            : { inventory_id: part_number, part_number: part_number });

      // Add to local storage for non-logged in users
      this.cartService.addToLocalStorage(
        fullItem,
        'Store Pickup',
        this.isScrapPart ? this.quantity : 1,
        this.unit,
      );
      this.itemAddedToCart = true;
      this.showGoToCartButton = true;
      this.cdr.detectChanges(); // Trigger change detection after updating state
      console.log(
        'Item added to local storage cart:',
        fullItem?.inventory_id,
      );
      return;
    }

    localStorage.removeItem('addtocartpart_type');
    localStorage.setItem(
      'addtocartpart_type',
      this.productDetailData.part_detail.part_type,
    );

    this.sub.add(
      this.cartService
        .addToCart(
          part_number,
          'Store Pickup',
          this.isScrapPart ? this.quantity : 1,
          this.unit,
        )
        .subscribe({
          next: () => {
            this.itemAddedToCart = true; // Set success state
            // this.notificationService.success('Item added to cart');
            this.cdr.detectChanges(); // Trigger change detection after updating state
          },
          error: (err) => {
            this.notificationService.error(
              err?.error?.data?.msg || 'Failed to add item to cart',
            );
          },
          complete: () => {
            // No loader needed
          },
        }),
    );
  }

  /**
   * Validates stock availability before adding to cart
   * Checks available quantity (stock - reserved) against requested quantity
   */
  private checkStockAvailability(): boolean {
    const product = this.productDetailData?.part_detail;
    if (!product) {
      this.notificationService.error('Product information not available.');
      return false;
    }

    // 1. Check if product is locked
    if (this.isProductLocked()) {
      this.notificationService.error(
        'This product is currently locked and unavailable for purchase.',
      );
      return false;
    }

    // 2. Check if product is active
    if (product.is_active !== 'True' && product.is_active !== true) {
      this.notificationService.error('This product is no longer available.');
      return false;
    }

    // 3. Check if seller is active
    if (product.seller_active !== 'True' && product.seller_active !== true) {
      this.notificationService.error('This seller is currently inactive.');
      return false;
    }

    // 4. Check part approval status
    if (product.part_status && product.part_status !== 'Approved') {
      this.notificationService.error('This product is pending approval.');
      return false;
    }

    // 5. Get stock and reserved quantities from API response
    const stockQuantity =
      Number(product.stock_quantity_s || product.STOCK_QUANTITY_s) || 0;
    const reservedQuantity =
      Number(product.reserved_quantity || product.RESERVED_QUANTITY_s) || 0;
    const availableQuantity =
      product.available_quantity !== undefined
        ? Number(product.available_quantity)
        : stockQuantity - reservedQuantity;

    // 6. Get requested quantity in base unit
    const requestedQuantity = this.quantity || 1;

    // 7. Validate quantity is valid number
    if (isNaN(requestedQuantity) || requestedQuantity <= 0) {
      this.notificationService.error('Please enter a valid quantity.');
      return false;
    }

    // 8. Check minimum quantity requirement
    const minQty = product.min_quantity || product.min_qty || 0;
    if (minQty > 0 && requestedQuantity < minQty) {
      const unit = this.unit || 'units';
      this.notificationService.error(`Minimum quantity is ${minQty} ${unit}.`);
      return false;
    }

    // 9. Check if no stock available
    if (availableQuantity <= 0) {
      this.notificationService.error('This product is currently out of stock.');
      return false;
    }

    // 10. Check if available stock exists and if requested quantity exceeds it
    if (requestedQuantity > availableQuantity) {
      const unit = this.unit || 'units';
      const errorMsg = `Insufficient stock. Available: ${availableQuantity} ${unit}, Requested: ${requestedQuantity} ${unit}.`;
      this.notificationService.error(errorMsg);
      return false;
    }

    // 11. Check maximum quantity (available_quantity)
    const maxQty = product.available_quantity || product.fix_qty || 0;
    if (maxQty > 0 && requestedQuantity > maxQty) {
      const unit = this.unit || 'units';
      this.notificationService.error(
        `Maximum available quantity is ${maxQty} ${unit}.`,
      );
      return false;
    }

    // 12. Check lot size compliance (if applicable)
    if (product.lot_size && Number(product.lot_size) > 1) {
      const lotSize = Number(product.lot_size);
      if (requestedQuantity % lotSize !== 0) {
        this.notificationService.error(
          `Quantity must be in multiples of ${lotSize}.`,
        );
        return false;
      }
    }

    // 13. Check if price is available
    if (!product.price_s && !product.discounted_price) {
      this.notificationService.error(
        'Price information not available for this product.',
      );
      return false;
    }

    return true;
  }

  goToCart() {
    this.cartService.navigateToCart();
  }

  isProductLocked(): boolean {
    const lockValue = this.productDetailData?.part_detail?.is_locked;
    if (typeof lockValue === 'string') {
      return lockValue.toLowerCase() === 'true';
    }
    return lockValue === true;
  }

  selectDeliveryOption(option: 'home' | 'store') {
    this.selectedDeliveryOption = option;
  }

  /**
   * Scrolls the page to the top
   */
  scrollToTop() {
    if (isPlatformBrowser(this.platformId)) {
      // Use smooth scrolling for better user experience
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  }

  /**
   * Handles scroll behavior based on navigation context
   */
  private handleScrollBehavior(preserveScroll: boolean) {
    if (preserveScroll) {
      // Let the router handle scroll restoration naturally
      // This will maintain the user's scroll position if they're coming from
      // a similar context (like similar products)
      return;
    } else {
      // Scroll to top for fresh navigation
      this.scrollToTop();
    }
  }

  ngOnDestroy() {
    // Cleanup subscriptions
    this.productSubscription.unsubscribe();
    this.routeSubscription.unsubscribe();
    this.sub.unsubscribe();

    // Complete and cleanup BehaviorSubject
    this.productData$.complete();

    // Clean up event listeners
    if (isPlatformBrowser(this.platformId)) {
      document.removeEventListener(
        'visibilitychange',
        this.handleVisibilityChange,
      );
      // Restore body scroll when component is destroyed
      this.modalService.closeModal('pdp-popups');
    }
  }

  onBuyNowClick() {
    // Mark quantity as touched when user tries to buy now (similar to product-list)
    this.quantityTouched = true;
    this.cdr.markForCheck();

    localStorage.removeItem('cartbooking_page_product_data');
    localStorage.removeItem('booking_page_product_data');
    // localStorage.setItem(
    //   'booking_page_product_data',
    //   JSON.stringify(this.productDetailData.part_detail.part_number)
    // );
    localStorage.setItem(
      'booking_page_product_data',
      JSON.stringify({
        part_number: this.productDetailData.part_detail.part_number,
        quantity: this.getSelectedQuantityInKg(),
      }),
    );

    if (!this.isQuantityValid()) {
      this.showQuantityError = true;
      this.notificationService.error(
        this.getQuantityErrorMessage() || 'Please select a valid quantity within the allowed range.',
      );
      this.cdr.markForCheck();
      return;
    }

    // Check certificate requirement
    const isCertRequired =
      this.productDetailData?.part_detail?.is_certificate_required === 'True';
    if (isCertRequired) {
      // Existing flow for certificate required
      if (this.scrapCertificateService.isScrapPart(this.productDetailData)) {
        if (!this.hasActiveSession()) {
          this.openLoginPopup('buy_now');
          return;
        }
        // For scrap parts, check certificate match before proceeding to buy now
        this.scrapCertificateService.handleAddToCart(
          this.productDetailData,
          () => {
            // Callback for when certificate matches - proceed with buy now
            this.proceedWithBuyNow();
          },
          () => {
            // Callback for login required
            this.openLoginPopup('buy_now');
          },
        );
        return;
      }
    }

    // If certificate is not required, or not a scrap part, proceed as normal
    if (!this.hasActiveSession()) {
      // User is not logged in, show popup for desktop or navigate for mobile
      this.openLoginPopup('buy_now');
      return;
    }
    // User is logged in, proceed with buy now animation and popup
    this.proceedWithBuyNow();
  }

  private proceedWithBuyNow() {
    this.isBuyNowAnimating = true;
    this.selectedBillingOption = undefined;
    // If Scrap Part, set delivery option to 'store' before opening popup
    if (this.productDetailData?.part_detail?.part_type === 'Scrap Part') {
      this.selectedDeliveryOption = 'store';
    } else {
      this.selectedDeliveryOption = 'home';
    }
    this.isBuyNowPopupOpen = true;
    this.updateBodyScroll();
    this.refreshUserDataAndAddresses();
    this.getPricebreakup();
    this.cdr.detectChanges();
  }

  closeBuyNowPopup() {
    this.isBuyNowPopupOpen = false;
    this.paymentErrorMessage = null;
    this.updateBodyScroll();
  }

  private showPaymentError(message: string): void {
    this.paymentErrorMessage = message;
    this.notificationService.error(message);
    this.cdr.markForCheck();
  }

  setDeliveryMethod(method: 'home' | 'pickup') {
    this.deliveryMethod = method;
  }

  makePayment() {
    // Implement payment logic here
    // alert('Proceeding to payment...');
    this.isBuyNowPopupOpen = false;
  }

  // Add method for Buy Now popup payment
  async onMakePayment() {
    this.paymentErrorMessage = null;

    if (!this.userData) {
      this.showPaymentError('Please login to continue with payment');
      return;
    }

    if (
      !this.hasAddress(this.userData?.billing_address) &&
      !this.hasAddress(this.userData?.shipping_address)
    ) {
      this.showPaymentError('Please select a billing address');
      return;
    }

    const orderGate =
      await this.buyerVerificationService.ensureCanCreateOrder(this.userData);
    if (!orderGate.allowed) {
      this.showPaymentError(orderGate.message);
      return;
    }

    // Add item to cart and proceed to payment
    const part_number = this.productDetailData?.part_detail?.part_number;
    // if (part_number) {
    //   this.addToCart(part_number);
    // }
    let calculatedQuantity = 1; // Default for used parts

    if (this.productDetailData?.part_detail?.part_type === 'Scrap Part') {
      if (this.unit === 'kg') {
        calculatedQuantity = this.quantity; // Keep as kg
      } else if (this.unit === 'ton') {
        calculatedQuantity = this.quantity * 1000; // Convert tons to kg
      }
    } else {
      calculatedQuantity = 1; // Used parts always have quantity 1
    }
    // "quantity": calculatedQuantity,

    // Construct parts data
    const partsData = [
      {
        part_number: part_number,
        inventory_id: this.productDetailData?.part_detail?.inventory_id,
        delivery_type:
          this.selectedDeliveryOption === 'store'
            ? 'Store Pickup'
            : 'Home Delivery',
        req_quantity: calculatedQuantity,
      },
    ];

    // Create FormData payload
    const payload = new FormData();
    payload.append('is_buy_now', 'true');
    payload.append('coupon_code', this.selectedCoupon?.coupon_code || '');
    payload.append('offer_id', this.selectedCoupon?.row_id || '');
    payload.append('parts', JSON.stringify(partsData));
    appendOnlinePaymentFields(payload, this.getOnlinePaymentPayload());

    localStorage.removeItem('createdOrderDetail');
    this.loaderService.show();
    this.sub.add(
      this.apiService.buyNow(payload).subscribe({
        next: (res) => {
          if (res.success) {
            this.orderDetail = res.data;
            localStorage.setItem(
              'createdOrderDetail',
              JSON.stringify(this.orderDetail),
            );
            this.oreder_number = this.orderDetail?.order_detail?.order_number;
            this.notificationService.success('Order created successfully.');
            this.initiatePayment();
            // this.router.navigate(['/order-confirmation'], {
            //   state: { orderDetail: this.orderDetail },
            // });
            this.makePayment();
          }
          this.loaderService.hide();
        },
        error: (err) => {
          this.notificationService.error(
            err?.error?.data?.msg ||
              'Failed to initiate payment. Please try again.',
          );
          this.loaderService.hide();
        },
        complete: () => {
          this.loaderService.hide();
        },
      }),
    );
  }

  async onMakeEnquiry() {
    this.paymentErrorMessage = null;

    if (!this.userData) {
      this.showPaymentError('Please login to continue with payment');
      return;
    }

    if (
      !this.hasAddress(this.userData?.billing_address) &&
      !this.hasAddress(this.userData?.shipping_address)
    ) {
      this.showPaymentError('Please select a billing address');
      return;
    }

    const orderGate =
      await this.buyerVerificationService.ensureCanCreateOrder(this.userData);
    if (!orderGate.allowed) {
      this.showPaymentError(orderGate.message);
      return;
    }

    const part_number = this.productDetailData?.part_detail?.part_number;
    let calculatedQuantity = 1; // Default for used parts

    if (this.productDetailData?.part_detail?.part_type === 'Scrap Part') {
      if (this.unit === 'kg') {
        calculatedQuantity = this.quantity; // Keep as kg
      } else if (this.unit === 'ton') {
        calculatedQuantity = this.quantity * 1000; // Convert tons to kg
      }
    } else {
      calculatedQuantity = 1; // Used parts always have quantity 1
    }

    // Construct parts data
    const partsData = [
      {
        part_number: part_number,
        inventory_id: this.productDetailData?.part_detail?.inventory_id,
        delivery_type:
          this.selectedDeliveryOption === 'store'
            ? 'Store Pickup'
            : 'Home Delivery',
        req_quantity: calculatedQuantity,
      },
    ];

    // Create FormData payload for enquiry
    const payload = new FormData();
    payload.append('is_buy_now', 'true');
    payload.append('coupon_code', this.selectedCoupon?.coupon_code || '');
    payload.append('offer_id', this.selectedCoupon?.row_id || '');
    payload.append('parts', JSON.stringify(partsData));
    payload.append('is_enquiry', 'true');

    localStorage.removeItem('createdOrderDetail');
    this.loaderService.show();
    this.sub.add(
      this.apiService.buyNow(payload).subscribe({
        next: (res) => {
          if (res.success) {
            this.orderDetail = res.data;
            localStorage.setItem(
              'createdOrderDetail',
              JSON.stringify(this.orderDetail),
            );
            this.oreder_number = this.orderDetail?.order_detail?.order_number;
            const enquiryNumber = this.orderDetail?.enquiry_numbers?.[0] || '';
            this.notificationService.success('Enquiry submitted successfully');
            this.closeBuyNowPopup();
            this.router.navigate(['/order-confirmation'], {
              queryParams: {
                success: 'true',
                order_id: this.oreder_number,
                is_enquiry: 'true',
                enquiry_number: enquiryNumber,
              },
              state: {
                orderDetail: this.orderDetail,
                isEnquiry: true,
                enquiryNumber,
              },
            });
          } else {
            this.showPaymentError(res?.data?.msg || 'Failed to submit enquiry');
          }
          this.loaderService.hide();
        },
        error: (err) => {
          this.showPaymentError(
            err?.error?.data?.msg ||
              'Failed to submit enquiry. Please try again.',
          );
          this.loaderService.hide();
        },
        complete: () => {
          this.loaderService.hide();
        },
      }),
    );
  }

  // Update existing billing option methods
  onBillingOptionChange(option: 'Billing' | 'gstin') {
    this.selectedBillingOption = option;
    if (option === 'Billing') {
      // Open address selection popup for billing (getAddressData called in openAddressSelection)
      this.openAddressSelection('billing');
    } else if (option === 'gstin') {
      if (!this.canAddGstDetails) {
        this.selectedBillingOption = null;
        return;
      }
      this.showGSTINPopup = true;
      this.updateBodyScroll();
    }
  }

  gotoOther() {
    localStorage.removeItem('viewOther');
    localStorage.setItem('viewOther', JSON.stringify(this.productDetailData));
    this.router.navigate(['/view-other']);
  }

  onCloseBillingDetails() {
    this.showBillingPopup = false;
    this.updateBodyScroll();
    this.cdr.markForCheck();
  }

  onCloseGSTINPopup() {
    this.showGSTINPopup = false;
    this.updateBodyScroll();
    this.cdr.markForCheck();
  }

  onSaveGSTINDetails(event: any) {
    console.log('GSTIN details saved:', event);
    this.showGSTINPopup = false;
    this.updateBodyScroll();
    this.refreshUserDataAndAddresses();
    this.cdr.markForCheck();
  }

  toggleFavorite(data: any) {
    // Check if user is logged in
    if (!this.userData || !this.userData.id) {
      // User is not logged in - save to localStorage instead
      const wishlistItem = {
        part_number: data?.part_detail?.part_number,
        total_quantity: this.isScrapPart ? this.getSelectedQuantityInKg() : 1,
        part_type: 'Scrap Part', //this.isScrapPart ? 'Scrap Part' : 'Used Part',
        price: data?.part_detail?.discounted_price
          ? data?.part_detail?.discounted_price
          : data?.part_detail?.price_s,
      };

      if (this.isFavorite) {
        // Remove from localStorage wishlist
        this.wishlistStorageService.removeFromLocalWishlist(
          data?.part_detail?.part_number,
        );
        this.isFavorite = false;
        this.notificationService.success('Removed from wishlist');
      } else {
        // Add to localStorage wishlist
        this.wishlistStorageService.addToLocalWishlist(wishlistItem);
        this.isFavorite = true;
        this.notificationService.success('Added to wishlist');
      }

      // Show login popup to encourage login
      this.openLoginPopup('wishlist');
      return;
    }

    // User is logged in - use API
    const payload: any = {
      action_type: this.isFavorite ? 'delete' : 'add_or_update',
    };

    if (this.isFavorite) {
      // Deleting from wishlist
      payload['wishlist_id_list'] = [this.wishlist[0].part_number];
    } else {
      // Adding to wishlist
      payload['wishlist_items'] = [
        {
          part_number: data?.part_detail?.part_number,
          total_quantity: this.isScrapPart ? this.getSelectedQuantityInKg() : 1,
          part_type: this.isScrapPart ? 'Scrap Part' : 'Used Part',
          price: data?.part_detail?.discounted_price
            ? data?.part_detail?.discounted_price
            : data?.part_detail?.price_s,
        },
      ];
    }

    this.sub.add(
      this.apiService.addToWishlist(payload).subscribe({
        next: () => {
          this.getWishlistData(data?.part_detail?.part_number);
          // Show appropriate message based on action type
          if (payload.action_type === 'delete') {
            this.notificationService.success('Removed from wishlist');
          } else {
            this.notificationService.success('Added to wishlist');
          }
          // Loader will be hidden in getWishlistData method
        },
        error: (err) => {
          this.loaderService.hide();
          console.error('Wishlist operation failed:', err);
          this.notificationService.error(
            err?.error?.data?.msg || 'Wishlist operation failed',
          );
        },
        complete: () => {
          // No need to hide loader here as it will be handled in getWishlistData
        },
      }),
    );
  }

  getWishlistData(part_number: any, showLoader: boolean = true) {
    // Check if user is logged in
    if (!this.userData || !this.userData.id) {
      // Check localStorage for wishlist
      this.isFavorite =
        this.wishlistStorageService.isInLocalWishlist(part_number);
      return;
    }

    const payload = {
      action_type: 'get',
      part_number: part_number,
      is_profile: false,
      offset: 0,
      limit: 10,
    };

    if (showLoader) {
      // this.loaderService.show();
    }

    this.sub.add(
      this.apiService.getWishlistData(payload).subscribe({
        next: (res) => {
          this.loaderService.hide();
          this.isFavorite = res?.data?.total_result > 0 ? true : false;
          this.wishlist = res.data.wishlist_items;
        },

        error: (err) => {
          this.loaderService.hide();
          console.error('Failed to fetch wishlist', err);
          this.notificationService.error(
            err?.error?.data?.msg || 'Failed to fetch wishlist',
          );
        },
      }),
    );
  }

  // Add new methods for address functionality
  openAddressSelection(type: 'shipping' | 'billing') {
    this.addressType = type;
    this.showAddressSelectionPopup = true;
    this.updateBodyScroll();
    this.getAddressData();
  }

  closeAddressSelection() {
    this.showAddressSelectionPopup = false;
    this.selectedAddressId = '';
    this.updateBodyScroll();
  }

  selectAddress(addressId: string) {
    this.selectedAddressId = addressId;
  }

  applyAddressSelection() {
    if (!this.selectedAddressId) {
      this.notificationService.error('Please select an address');
      return;
    }

    const payload = {
      id: this.selectedAddressId,
      shipping_address: this.addressType === 'shipping' ? true : '',
      billing_address: this.addressType === 'billing' ? true : '',
    };

    this.sub.add(
      this.apiService.updateAdress(payload).subscribe({
        next: (res) => {
          this.getUserDetails();
          this.getAddressData();
          this.closeAddressSelection();
          // this.notificationService.success('Address updated successfully');
        },
        error: (err) => {
          console.error('Error updating address:', err);
          this.notificationService.error(
            err?.error?.data?.msg || 'Failed to update address',
          );
        },
      }),
    );
  }

  addNewAddress() {
    this.closeAddressSelection();
    // Open address form with the correct type
    this.showBillingPopup = true;
    this.updateBodyScroll();
  }

  getAddressData() {
    this.loaderService.show();
    const payload = {
      offset: 0,
      limit: 10,
    };

    this.sub.add(
      this.apiService.getAddressData(payload).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.addresses = res.data;
            console.log('Address data received:', this.addresses);
          }
          this.loaderService.hide();
        },
        error: (err) => {
          console.error('Error fetching address data:', err);
          this.notificationService.error(
            err?.error?.data?.msg || 'Failed to fetch address data',
          );
          this.loaderService.hide();
        },
        complete: () => {
          this.loaderService.hide();
        },
      }),
    );
  }

  getUserDetails() {
    this.loaderService.show();
    const payload = {};
    this.sub.add(
      this.apiService.getUserDetails(payload).subscribe({
        next: (res) => {
          localStorage.setItem('userData1', JSON.stringify(res?.data));
          this.userData = res?.data;
          console.log('User details updated:', res);
          this.loaderService.hide();
        },
        error: (err) => {
          console.error('Failed to fetch user details', err);
          this.notificationService.error(
            err?.error?.data?.msg || 'Failed to fetch user details',
          );
          this.loaderService.hide();
        },
        complete: () => {
          this.loaderService.hide();
        },
      }),
    );
  }

  onSaveAddressDetails(event: any) {
    console.log('Address details saved:', event);
    this.showBillingPopup = false;
    this.updateBodyScroll();
    this.refreshUserDataAndAddresses();
    this.cdr.markForCheck();
  }

  hasAddress(address: any): boolean {
    return hasAddressUtil(address);
  }

  formatAddress(address: any): string {
    return formatAddressUtil(address);
  }

  shouldShowBillingBlock(): boolean {
    return shouldShowBillingBlockUtil(this.userData, {
      isScrapOrStorePickup: this.isScrapPart,
      selectedBillingOption: this.selectedBillingOption,
    });
  }

  getBillingDisplayName(): string {
    const billing = this.userData?.billing_address;
    const shipping = this.userData?.shipping_address;
    const source =
      this.hasAddress(billing) &&
      (this.isScrapPart ||
        billing?.id !== shipping?.id ||
        this.selectedBillingOption === 'Billing' ||
        this.selectedBillingOption === 'gstin')
        ? billing
        : shipping;

    return (
      source?.receiver_name ||
      source?.company_name ||
      `${this.userData?.first_name || ''} ${this.userData?.last_name || ''}`.trim()
    );
  }

  getBillingAddressType(): string {
    const billing = this.userData?.billing_address;
    const shipping = this.userData?.shipping_address;
    if (
      this.hasAddress(billing) &&
      (this.isScrapPart || billing?.id !== shipping?.id)
    ) {
      return billing?.address_type || '';
    }
    return shipping?.address_type || '';
  }

  get billingAddress(): string {
    const billing = this.userData?.billing_address;
    const shipping = this.userData?.shipping_address;
    if (
      this.hasAddress(billing) &&
      (this.isScrapPart ||
        billing?.id !== shipping?.id ||
        this.selectedBillingOption === 'Billing' ||
        this.selectedBillingOption === 'gstin')
    ) {
      return this.formatAddress(billing);
    }
    return this.formatAddress(shipping);
  }

  get billingGST(): string {
    return this.userData?.billing_address?.gstin_number || 'No GSTIN';
  }

  onBillingChangeClick(): void {
    if (this.selectedBillingOption === 'gstin') {
      this.showGSTINPopup = true;
      this.updateBodyScroll();
      return;
    }
    this.openAddressSelection('billing');
  }

  // Add coupon methods
  openCouponPopup() {
    // Lazy-load coupons only when user opens coupon UI
    if (!this.couponsLoaded) {
      this.fetchCouponsData();
    }
    this.showCouponPopup = true;
    this.updateBodyScroll();
  }

  closeCouponPopup() {
    this.showCouponPopup = false;
    this.updateBodyScroll();
  }

  onSaveCouponDetails(event: any) {
    this.selectedCoupon = event;
    console.log('Coupon details saved:', event);

    // If a coupon is selected or removed, refresh price breakup (use debounced version)
    if (event !== null || event === null) {
      this.triggerPriceBreakupUpdate();

      // Show appropriate message
      if (event !== null) {
        this.notificationService.success('Coupon applied successfully');
      } else {
        this.notificationService.success('Coupon removed');
      }
    }

    this.showCouponPopup = false;
    this.updateBodyScroll();
  }

  fetchCouponsData() {
    if (this.couponsLoaded) {
      return;
    }
    if (!this.productDetailData?.part_detail) {
      return;
    }

    const partDetail = this.productDetailData.part_detail;

    // Calculate quantity in kg for the payload
    let totalQuantity: number;
    if (this.isScrapPart) {
      if (this.unit === 'kg') {
        totalQuantity = this.quantity || 0;
      } else if (this.unit === 'liter') {
        totalQuantity = this.quantity || 0;
      } else {
        // For ton units
        totalQuantity = (this.quantity || 0) * 1000; // Convert tons to kg
      }
    } else {
      totalQuantity = this.quantity || 1;
    }

    const allItems: any[] = [
      {
        negotiated_price:
          partDetail.negotiated_price ||
          partDetail.discounted_price ||
          partDetail.price_s ||
          0,
        discounted_taxable: partDetail.discounted_taxable || 0,
        total_quantity: totalQuantity,
        part_type: partDetail.part_type || '',
        part_number: partDetail.part_number || '',
        scrap_category: partDetail.scrap_category || partDetail.category || '',
        seller_code: partDetail.seller_code_s || '',
        make: partDetail.make || '',
        model: partDetail.model || '',
        tax_s: partDetail.tax_s || 0,
        final_total: partDetail.final_total || 0,
      },
    ];

    const payload = {
      items: allItems,
    };

    this.sub.add(
      this.apiService.getBuyerBestOffer(payload).subscribe({
        next: (response: any) => {
          if (response && response.success && response.data) {
            // Transform the data to match coupon component expectations
            this.availableCoupons = response.data.map((coupon: any) => ({
              ...coupon,
              savings: coupon.discount_amount || 0,
              isActive: true,
            }));
            console.log('Available coupons:', this.availableCoupons);
            if (this.availableCoupons.length === 0) {
              console.log('No coupons available for this product');
            }
          } else {
            this.availableCoupons = [];
            console.log('No coupons available');
          }
          this.couponsLoaded = true;
        },
        error: (error: any) => {
          console.error('Error fetching coupons:', error);
          this.availableCoupons = [];
          this.notificationService.error(
            error?.error?.data?.msg || 'Failed to fetch coupons',
          );
          this.couponsLoaded = false;
        },
      }),
    );
  }

  copyToClipboard(text: string) {
    if (isPlatformBrowser(this.platformId)) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          console.log('Coupon code copied:', text);
          this.notificationService.success('Coupon code copied to clipboard');
        })
        .catch((err) => {
          console.error('Failed to copy coupon code:', err);
          this.notificationService.error('Failed to copy coupon code');
        });
    }
  }

  // Add method to handle login popup logic
  openLoginPopup(action: string = 'buy_now'): void {
    this.currentAction = action;
    // For both mobile and desktop users, open login modal
    this.showLoginModal = true;
    this.updateBodyScroll();
  }

  closeLoginPopup() {
    this.showLoginModal = false;
    this.updateBodyScroll();
    if (this.hasActiveSession()) {
      this.getUserDetails();
    }
  }

  onLoginBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.closeLoginPopup();
    }
  }

  /** Read the session AuthService already published, then fall back to storage. */
  private applyStoredUser(): void {
    const authUser = this.authService.userData;
    if (authUser?.id || authUser?.user_code) {
      this.userData = authUser;
      return;
    }

    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    try {
      const userDataString = localStorage.getItem('userData1');
      if (userDataString && !userDataString.startsWith('U2FsdGVkX1')) {
        const parsed = JSON.parse(userDataString);
        if (parsed?.id || parsed?.user_code) {
          this.userData = parsed;
        }
      }
    } catch (error) {
      console.error('Error parsing userData1 from localStorage:', error);
    }
  }

  private hasActiveSession(): boolean {
    if (!this.authService.isLoggedIn) {
      return false;
    }
    this.applyStoredUser();
    return true;
  }

  isSocialShareOpen: boolean = false;
  pageURL: string = window.location.href; // or set as needed

  openSocialSharePopup() {
    this.isSocialShareOpen = true;
    this.updateBodyScroll();
  }

  closeSocialSharePopup() {
    this.isSocialShareOpen = false;
    this.updateBodyScroll();
  }

  copyMessage() {
    navigator.clipboard
      .writeText(this.pageURL)
      .then(() => {
        this.notificationService.success('Link copied to clipboard');
      })
      .catch((err) => {
        console.error('Failed to copy link:', err);
        this.notificationService.error('Failed to copy link');
      });
  }

  //   viewOther(){
  //  this.router.navigate(['/compare'],{queryParams : {type:this.isScrapPart ? 'Scrap part':' Used part'}});
  //   }

  isPopupVisible = false;

  togglePopup() {
    this.isPopupVisible = !this.isPopupVisible;
    this.updateBodyScroll();
  }
  getBenefits() {
    if (this.isScrapPart) {
      return this.Scrapbenefits;
    } else {
      return this.benefits;
    }
  }

  // Add properties for scrap certificate modal
  showScrapCertificateModal = false;
  scrapCategories = [
    'Engine Parts',
    'Transmission',
    'Electrical',
    'Body Parts',
    'Suspension',
    'Brakes',
    'Interior',
    'Other',
  ];
  ImageAray: any[] = [];
  fileValidationErrors: string[] = [];
  selectedScrapCategory = '';
  showGoToCartButton = false; // Track if we should show "Go to Cart" button for scrap items

  // Scrap certificate form properties
  certificateForm!: FormGroup;
  scrapList: any[] = [];
  // showScrapCertificateModal = false;

  // Add methods for scrap certificate modal
  openScrapCertificateModal() {
    this.showScrapCertificateModal = true;
    // Load scrap list when modal opens (only if not already loaded)
    if (!this.scrapList || this.scrapList.length === 0) {
      this.getScrapCertificateList();
    }
    this.updateBodyScroll();
  }

  closeModal() {
    // Centralize via shared service to keep state consistent
    this.scrapCertificateService.closeScrapCertificateModal();
    this.updateBodyScroll();
  }

  removeImage(img: string) {
    const index = this.ImageAray.indexOf(img);
    if (index > -1) {
      this.ImageAray.splice(index, 1);
    }
  }

  onScrapCategoryChange(event: Event) {
    const select = event.target as HTMLSelectElement;
    this.selectedScrapCategory = select.value;
  }

  triggerFileInput() {
    if (this.addMoreFileInput) {
      this.addMoreFileInput.nativeElement.click();
    }
  }

  // File validation function for scrap certificate uploads
  private validateFile(file: File): { isValid: boolean; error?: string } {
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    // Do not allow file names with a leading space
    if (/^\s/.test(file.name)) {
      return {
        isValid: false,
        error: `File name should not start with a space.`,
      };
    }
    if (!allowedTypes.includes(file.type)) {
      return {
        isValid: false,
        error: `File \"${file.name}\" is not a valid image format. Only JPG and PNG files are allowed.`,
      };
    }
    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      return {
        isValid: false,
        error: `File \"${file.name}\" is too large. Maximum file size is 5MB.`,
      };
    }
    return { isValid: true };
  }

  saveScrapCertificate() {
    if (this.ImageAray.length === 0) {
      this.notificationService.error('Please upload at least one certificate');
      return;
    }

    // Here you would typically send the certificate data to your API
    console.log('Saving scrap certificate:', {
      images: this.ImageAray,
    });

    // Close modal after saving
    this.closeModal();

    // this.notificationService.success('Certificate uploaded successfully');

    // Add item to cart after successful certificate upload
    const part_number = this.productDetailData?.part_detail?.part_number;
    if (part_number) {
      this.addScrapItemToCart(part_number);
    }

    // Reset form
    this.selectedScrapCategory = '';
    this.ImageAray = [];
  }

  addScrapItemToCart(part_number: any) {
    // Check if user is logged in
    if (!this.userData || !this.userData.id) {
      // Get quantity and unit for scrap parts
      const quantity = this.isScrapPart ? this.quantity : 1;
      const unit = this.unit === 'kg' ? 'Kg' : 'Ton';

      const fullItem = this.productDetailData?.part_detail
        ? {
            ...this.productDetailData.part_detail,
            inventory_id:
              this.productDetailData.part_detail.inventory_id ||
              part_number ||
              this.productDetailData.part_detail.part_number,
          }
        : (typeof this.productDetailData === 'object' && this.productDetailData !== null
            ? this.productDetailData
            : { inventory_id: part_number, part_number: part_number });

      // Add to local storage for non-logged in users with complete product data
      this.cartService.addToLocalStorage(
        fullItem,
        'Store Pickup',
        quantity,
        unit,
      );
      this.itemAddedToCart = true;
      this.showGoToCartButton = true; // Show "Go to Cart" button
      // this.notificationService.success('Scrap item added to cart successfully');
      this.cdr.detectChanges(); // Trigger change detection after updating state
      console.log('Scrap item added to local storage cart:', fullItem?.inventory_id);
      return;
    }

    // Get quantity and unit for scrap parts
    const quantity = this.isScrapPart ? this.quantity : 1;
    const unit = this.unit === 'kg' ? 'Kg' : 'Ton';

    this.loaderService.show();
    this.sub.add(
      this.cartService
        .addToCart(part_number, 'Store Pickup', quantity, unit)
        .subscribe({
          next: () => {
            this.itemAddedToCart = true; // Set success state
            this.showGoToCartButton = true; // Show "Go to Cart" button
            // this.notificationService.success('Scrap item added to cart successfully');
            this.cdr.detectChanges(); // Trigger change detection after updating state
            this.loaderService.hide();
            // Show success message for 3 seconds, then navigate to cart
            setTimeout(() => {
              this.cartService.navigateToCart();
            }, 3000);
          },
          error: (err) => {
            this.notificationService.error(
              err?.error?.data?.msg || 'Failed to add scrap item to cart',
            );
            this.loaderService.hide();
          },
          complete: () => {
            this.loaderService.hide();
          },
        }),
    );
  }

  get hasImages(): boolean {
    return Array.isArray(this.ImageAray) && this.ImageAray.length > 0;
  }

  // Form validation methods
  isFieldInvalid(fieldName: string): boolean {
    const field = this.certificateForm.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }

  getFieldError(fieldName: string): string {
    const field = this.certificateForm.get(fieldName);
    if (field && field.errors) {
      if (field.errors['required']) {
        return `${fieldName} is required`;
      }
      if (field.errors['email']) {
        return 'Please enter a valid email address';
      }
      if (field.errors['minlength']) {
        return `${fieldName} must be at least ${field.errors['minlength'].requiredLength} characters`;
      }
      if (field.errors['pattern']) {
        if (fieldName === 'certificateNumber') {
          return 'Certificate Number can only contain letters, numbers, and allowed characters (- / . _ # :)';
        }
        return `${fieldName} can only contain letters, numbers, and allowed characters (- / . , & ( ) ' : _ #)`;
      }
    }
    return '';
  }

  // File upload methods
  onFileUpload(event: any) {
    const files = event.target.files;
    this.fileValidationErrors = [];
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const validation = this.validateFile(file);
        if (!validation.isValid) {
          this.fileValidationErrors.push(validation.error!);
          continue;
        }
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.ImageAray.push(e.target.result);
        };
        reader.onerror = () => {
          this.fileValidationErrors.push(`Error reading file: ${file.name}`);
        };
        reader.readAsDataURL(file);
      }
    }
  }

  onFileSelected(event: any) {
    const files = event.target.files;
    this.fileValidationErrors = [];
    if (files && files.length > 0) {
      const file = files[0]; // Get the first file

      // Update the fileName property to display in the UI
      this.fileName = file.name;

      // Store the file in the form control for part request form
      this.partForm.patchValue({
        attachment: file,
      });

      // Also handle multiple files for scrap certificate modal if needed
      for (let i = 0; i < files.length; i++) {
        const currentFile = files[i];
        const validation = this.validateFile(currentFile);
        if (!validation.isValid) {
          this.fileValidationErrors.push(validation.error!);
          continue;
        }
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.ImageAray.push(e.target.result);
        };
        reader.onerror = () => {
          this.fileValidationErrors.push(
            `Error reading file: ${currentFile.name}`,
          );
        };
        reader.readAsDataURL(currentFile);
      }
    }
  }

  // Form submission
  onSubmit() {
    if (this.certificateForm.valid) {
      this.saveScrapCertificate();
    } else {
      // Mark all fields as touched to show validation errors
      Object.keys(this.certificateForm.controls).forEach((key) => {
        this.certificateForm.get(key)?.markAsTouched();
      });
    }
  }

  hasBookingAmount(): boolean {
    return (
      toAmountNumber(this.priceBreakup?.scrap_booking_amount) > 0 ||
      toAmountNumber(
        this.productDetailData?.part_detail?.scrap_booking_amount,
      ) > 0 ||
      toAmountNumber(this.productDetailData?.part_detail?.booking_amount) > 0
    );
  }

  getBasePrice(): number {
    const orderTotal = Number(
      this.priceBreakup?.order_total || this.priceBreakup?.orderTotal || 0,
    );
    if (orderTotal > 0) {
      return orderTotal;
    }
    if (this.priceBreakup?.base_price && Number(this.priceBreakup.base_price) > 0) {
      return Number(this.priceBreakup.base_price);
    }
    const partDetail = this.productDetailData?.part_detail;
    if (this.isScrapPart || partDetail?.part_type === 'Scrap Part') {
      const qty = this.unit === 'ton' ? this.quantity * 1000 : this.quantity;
      const rate = partDetail?.discounted_taxable
        ? Number(partDetail.discounted_taxable)
        : (Number(partDetail?.taxable_amount) || Number(partDetail?.price_s) || 0);
      return rate * (qty || 1);
    }
    const price = Number(partDetail?.discounted_price || partDetail?.price_s || 0);
    return price * (this.quantity || 1);
  }

  getOriginalBasePrice(): number {
    const partDetail = this.productDetailData?.part_detail;
    const qty = this.unit === 'ton' ? this.quantity * 1000 : this.quantity;
    if (this.isScrapPart || partDetail?.part_type === 'Scrap Part') {
      const originalRate = Number(
        partDetail?.taxable_amount || partDetail?.price_s || 0,
      );
      if (originalRate > 0) {
        return originalRate * (qty || 1);
      }
    }
    const originalPrice = Number(
      partDetail?.price_s || partDetail?.taxable_amount || 0,
    );
    return originalPrice * (this.quantity || 1);
  }

  getBalanceAmount(): number {
    const remaining = Number(
      this.priceBreakup?.remaining_booking_amount ||
        this.priceBreakup?.remainingBookingAmount ||
        0,
    );
    if (remaining > 0) {
      return remaining;
    }
    const base = this.getBasePrice();
    const booking = Number(
      this.priceBreakup?.scrap_booking_amount ||
        this.productDetailData?.part_detail?.scrap_booking_amount ||
        this.productDetailData?.part_detail?.booking_amount ||
        0,
    );
    return Math.max(base - booking, 0);
  }

  getBookingPercentage(): string {
    if (this.priceBreakup?.booking_percent_rule) {
      return this.priceBreakup.booking_percent_rule.toString();
    }
    const partDetail = this.productDetailData?.part_detail;
    if (partDetail?.booking_percent_rule) {
      return partDetail.booking_percent_rule.toString();
    }
    if (this.productDetailData?.booking_percent_rule) {
      return this.productDetailData.booking_percent_rule.toString();
    }
    const base = this.getBasePrice();
    const booking = Number(
      this.priceBreakup?.scrap_booking_amount ||
        partDetail?.scrap_booking_amount ||
        partDetail?.booking_amount ||
        0,
    );
    if (booking > 0 && base > 0) {
      const pct = Math.round((booking / base) * 100);
      if (pct > 0 && pct <= 100) return pct.toString();
    }
    return '';
  }

  getOnlinePaymentPayload() {
    return getOnlinePaymentFields({
      payFullAmount: this.payFullAmount,
      bookingAmount:
        this.priceBreakup?.scrap_booking_amount ||
        this.productDetailData?.part_detail?.scrap_booking_amount ||
        this.productDetailData?.part_detail?.booking_amount,
      totalAmount:
        this.priceBreakup?.total_amount ||
        this.productDetailData?.part_detail?.discounted_price,
    });
  }

  getPayableAmount(): number {
    return this.getOnlinePaymentPayload().online_amount;
  }

  formatPriceBreakup(val: unknown): string {
    const num = Math.abs(toAmountNumber(val));
    if (!num || num === 0) {
      return '0';
    }
    return Number.isInteger(num) ? num.toString() : num.toFixed(2);
  }

  onPayFullAmountChange(checked: boolean): void {
    this.payFullAmount = !!checked;
    this.showFullPaymentConfirm = false;
    this.cdr.detectChanges();
    this.getPricebreakup();
  }

  confirmFullPayment(): void {
    this.payFullAmount = true;
    this.showFullPaymentConfirm = false;
    this.cdr.detectChanges();
    this.getPricebreakup();
  }

  cancelFullPayment(): void {
    this.payFullAmount = false;
    this.showFullPaymentConfirm = false;
    this.cdr.detectChanges();
  }

  // Load scrap list

  scrollToCompareSection() {
    console.log('scrollToCompareSection method called'); // Debug log
    // Use setTimeout to ensure the DOM is fully rendered
    setTimeout(() => {
      const compareElement = document.getElementById('compare-section');
      console.log('Looking for compare element:', compareElement); // Debug log
      if (compareElement) {
        console.log('Scrolling to compare section'); // Debug log
        compareElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      } else {
        console.warn('Compare section element not found');
      }
    }, 100);
  }

  initiatePayment() {
    if (!this.oreder_number) {
      console.error('Order number not available');
      this.notificationService.error(
        'Order number not available. Please try again.',
      );
      return;
    }

    // Create payment request payload
    const paymentPayload = {
      order_number: this.oreder_number,
      payment_flow: this.getOnlinePaymentPayload().payment_flow,
    };

    console.log('Initiating payment with payload:', paymentPayload);

    // Call payment service to get encrypted payment data
    this.sub.add(
      this.paymentService.getEncryptedPaymentData(paymentPayload).subscribe({
        next: (response: any) => {
          if (response.success && response.data) {
            console.log('Payment data received:', response.data);
            this.ccavenue = response?.data;
            let encRequest = response?.data;
            let ccavenuForm: FormGroup = this.formBuilder.group({
              encRequest: [encRequest],
              access_code: [this.ccavenue?.access_code],
            });
            this.payWithCcavenu(ccavenuForm);

            // Update payment status
            // this.paymentService.updatePaymentStatus({ status: 'in_progress' });
            // this.isPaymentInProgress = true;

            // Store payment data
            // this.paymentService.updatePaymentData(response.data);

            // Handle successful payment data
            // this.handlePaymentData(response.data);
          } else {
            console.error('Payment failed:', response.error);
            this.notificationService.error(
              response?.error?.data?.msg || 'Failed to get payment data',
            );
          }
        },
        error: (error: any) => {
          console.error('Payment service error:', error);
          this.notificationService.error(
            error?.error?.data?.msg ||
              'Payment service error. Please try again.',
          );
        },
      }),
    );
  }

  payWithCcavenu(formGroup: FormGroup) {
    console.log(
      'payWithCcavenu method called with formGroup:',
      formGroup.value,
    );
    console.log('ccavenue object:', this.ccavenue);

    // localStorage.removeItem('productOfferData');

    if (!this.ccavenue || !this.ccavenue.ccavenue_url) {
      console.error('CCavenue configuration not available');
      this.notificationService.error('Payment gateway configuration error');
      return;
    }

    const myform = document.createElement('form');
    myform.method = 'POST';

    // Fix the action URL construction
    const baseUrl = this.ccavenue.ccavenue_url;
    const separator = baseUrl.includes('?') ? '&' : '?';
    myform.action = `${baseUrl}${separator}encRequest=${this.ccavenue.encRequest}&access_code=${this.ccavenue.access_code}`;

    console.log('Form action URL:', myform.action);

    let input: any;
    for (const [key, value] of Object.entries(formGroup.value)) {
      input = document.createElement('input');
      input.name = key;
      input.id = key;
      input.value = value;
      myform.appendChild(input);
    }

    myform.style.display = 'none';

    // Remove invalid append calls - these are not valid for form elements
    // myform.append("Content-Type", "application/x-www-form-urlencoded");
    // myform.append("Accept", "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8");

    document.body.appendChild(myform);
    console.log('Form submitted to:', myform.action);
    myform.submit();
  }

  getPricebreakup() {
    let calculatedQuantity = 1;
    const partDetail = this.productDetailData?.part_detail;
    const partType = partDetail?.part_type || this.productDetailData?.part_type;
    const unit = (this.unit || '').toLowerCase();

    if (partType === 'Scrap Part') {
      if (unit === 'kg' || unit === 'liter' || unit === 'litr') {
        calculatedQuantity = this.quantity;
      } else if (unit === 'ton') {
        calculatedQuantity = this.quantity * 1000;
      }
    }

    const pricePerUnit =
      partDetail?.discounted_price || partDetail?.price_s || 0;
    const calculatedOrderTotal = pricePerUnit * calculatedQuantity;

    const payload: Record<string, unknown> = {
      coupon_code: this.selectedCoupon?.coupon_code || '',
      offer_id: this.selectedCoupon?.row_id || '',
      parts: [
        {
          part_number: partDetail?.part_number,
          part_type: partType,
          total_quantity: calculatedQuantity,
          order_total: calculatedOrderTotal,
          booking_amount:
            this.priceBreakup?.scrap_booking_amount ||
            partDetail?.scrap_booking_amount ||
            partDetail?.booking_amount,
          booking_percent_rule: partDetail?.booking_percent_rule,
        },
      ],
    };
    assignPaymentFlow(payload, this.getOnlinePaymentPayload().payment_flow);

    this.loaderService.show();
    this.sub.add(
      this.apiService.getBuyNowPriceBreakup(payload).subscribe({
        next: (res) => {
          const breakup = extractPriceBreakup(res);
          if (res.success && breakup) {
            this.priceBreakup = { ...breakup };
          }
          this.loaderService.hide();
          this.cdr.detectChanges();
        },
        error: (err) => {
          // console.error('Error getting price breakup:', err);
          this.priceBreakup = {};
          this.cdr.detectChanges();
          this.notificationService.error(
            err?.error?.data?.msg || 'Failed to get price breakup',
          );
          this.loaderService.hide();
        },
      }),
    );
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: PopStateEvent) {
    this.router.navigate(['/product-list']);
  }

  private addPageVisibilityListener() {
    if (isPlatformBrowser(this.platformId)) {
      document.addEventListener(
        'visibilitychange',
        this.handleVisibilityChange,
      );
    }
  }

  /**
   * Handle visibility change for cleanup
   */
  private handleVisibilityChange = () => {
    console.log('handleVisibilityChange called in product detail');
    // This method is bound to this context for proper cleanup
    if (!document.hidden) {
      console.log('Page became visible - checking for payment gateway return');
      setTimeout(() => {}, 1000);
    }
  };

  getScrapCertificateList() {
    this.loaderService.show();
    try {
      const payload = {
        action_type: '',
        status: ['Valid', 'Expiring Soon'],
      }; // Provide appropriate payload as required by the API

      this.sub.add(
        this.apiService.getScrapCertificateList(payload).subscribe({
          next: (value) => {
            if (value.success) {
              this.scrapList = value?.data?.scrap_certificate_list;
              // Map API response to certificates array for template binding

              this.loaderService.hide();
            } else {
              this.loaderService.hide();
            }
          },
          error: (err) => {
            console.error('Error loading scrap certificate list:', err);
            this.scrapList = [];
            this.notificationService.error(
              err?.error?.data?.msg || 'Failed to load scrap certificate list',
            );
            this.loaderService.hide();
          },
        }),
      );
    } catch (error) {
      console.error('Error in scrap certificate list:', error);
      this.scrapList = [];
      this.loaderService.hide();
    }
  }

  /**
   * Check if product is oil category with liter UOM
   */
  isOilProductWithLiter(product: any): boolean {
    if (!product) return false;

    // Check if default_uom is liter/litr/ltr (API returns "ltr")
    const isLiterUom =
      product.default_uom?.toLowerCase() === 'ltr' ||
      product.default_uom?.toLowerCase() === 'litr' ||
      product.default_uom?.toLowerCase() === 'liter' ||
      product.defaultUom?.toLowerCase() === 'ltr' ||
      product.defaultUom?.toLowerCase() === 'litr' ||
      product.defaultUom?.toLowerCase() === 'liter';

    if (!isLiterUom) return false;

    // Check if category contains oil or fluids (using includes for "OIL / Fluids" format)
    const scrapCategoryLower = product.scrap_category?.toLowerCase() || '';
    const categoryLower = product.category?.toLowerCase() || '';
    const materialLower = product.material?.toLowerCase() || '';
    const materialCompositionLower =
      product.material_composition?.toLowerCase() || '';
    const nameLower = product.name?.toLowerCase() || '';

    const isOilCategory =
      scrapCategoryLower.includes('oil') ||
      scrapCategoryLower.includes('fluids') ||
      categoryLower.includes('oil') ||
      categoryLower.includes('fluids') ||
      materialLower.includes('oil') ||
      materialLower.includes('fluids') ||
      materialCompositionLower.includes('oil') ||
      materialCompositionLower.includes('fluids') ||
      nameLower.includes('oil') ||
      nameLower.includes('fluids');

    const result = isOilCategory && isLiterUom;

    // Debug log for PDP
    console.log('🔍 PDP isOilProductWithLiter called:', {
      name: product.table_name || product.name,
      default_uom: product.default_uom,
      material: product.material,
      scrap_category: product.scrap_category,
      isLiterUom: isLiterUom,
      isOilCategory: isOilCategory,
      result: result,
    });

    return result;
  }

  // Get selected quantity in kg (similar to product-list's getSelectedQuantity)
  getSelectedQuantityInKg(): number {
    if (!this.productDetailData?.part_detail) return 0;

    // Convert current quantity to kg for validation
    let quantityInKg = this.quantity;
    if (this.unit === 'ton') {
      quantityInKg = this.quantity * 1000;
    } else if (this.unit === 'liter') {
      // For liter, quantity is already in liters, but we need to compare with min_qty in kg
      // Assuming 1 liter = 1 kg for validation purposes (adjust if needed)
      quantityInKg = this.quantity;
    }

    return quantityInKg;
  }

  isQuantityValid(): boolean {
    const selectedQtyInKg = this.getSelectedQuantityInKg();
    const partDetail = this.productDetailData?.part_detail;

    if (!partDetail) return false;

    // Check if quantity is selected (not 0, null, or undefined)
    if (
      selectedQtyInKg === 0 ||
      selectedQtyInKg === null ||
      selectedQtyInKg === undefined
    ) {
      return false;
    }

    // Get min and max from API
    const minQtyInKg = partDetail.min_quantity || partDetail.min_qty || 0;
    const maxQtyInKg =
      partDetail.max_booking_qty ||
      partDetail.max_booking_quantity ||
      partDetail.max_quantity ||
      partDetail.available_quantity ||
      0;

    // For Used Parts, if available_quantity is not set, skip validation (allow any quantity)
    if (partDetail.part_type !== 'Scrap Part' && maxQtyInKg === 0) {
      return true;
    }

    // Validate against API values
    if (minQtyInKg > 0 && selectedQtyInKg < minQtyInKg) {
      return false;
    }

    if (maxQtyInKg > 0 && selectedQtyInKg > maxQtyInKg) {
      return false;
    }

    return true;
  }

  // Add a method to get error message (matching product-list validation pattern)
  getQuantityErrorMessage(): string {
    const selectedQtyInKg = this.getSelectedQuantityInKg();
    const partDetail = this.productDetailData?.part_detail;

    if (!partDetail) return '';

    // Don't show error if quantity is 0/null/undefined (handled by specific message)
    if (
      selectedQtyInKg === 0 ||
      selectedQtyInKg === null ||
      selectedQtyInKg === undefined
    ) {
      return '';
    }

    // Get min and max from API
    const minQtyInKg = partDetail.min_quantity || partDetail.min_qty || 0;
    const maxQtyInKg =
      partDetail.max_booking_qty ||
      partDetail.max_booking_quantity ||
      partDetail.max_quantity ||
      partDetail.available_quantity ||
      0;

    // Don't show error if quantity is less than min_qty (handled by specific message)
    if (minQtyInKg > 0 && selectedQtyInKg > 0 && selectedQtyInKg < minQtyInKg) {
      return '';
    }

    // Check if quantity exceeds API maximum
    if (maxQtyInKg > 0 && selectedQtyInKg > maxQtyInKg) {
      const maxInSelectedUnit =
        this.unit === 'ton' ? maxQtyInKg / 1000 : maxQtyInKg;
      return `Maximum order quantity is ${maxInSelectedUnit} ${this.unit}`;
    }

    return '';
  }
  preventLeadingSpace(event: KeyboardEvent, input: any) {
    const key = event.key;

    // Prevent space if it's the first character
    if (key === ' ' && (!input.value || input.selectionStart === 0)) {
      event.preventDefault();
      return;
    }

    // Allow letters, space, backspace, tab, and arrow keys
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', ' '];
    if (!/^[a-zA-Z]$/.test(key) && !allowedKeys.includes(key)) {
      event.preventDefault();
    }
  }

  /**
   * Trigger debounced price breakup update
   */
  private triggerPriceBreakupUpdate(): void {
    this.priceBreakupSubject$.next();
  }

  /**
   * Refresh user details and address data in a single optimized call
   */
  private refreshUserDataAndAddresses(): void {
    if (this.hasActiveSession()) {
      this.getUserDetails();
      this.getAddressData();
    }
  }
}
